import { render, staticRenderFns } from "./game-redpipe.vue?vue&type=template&id=16a2531a"
import script from "./game-redpipe.vue?vue&type=script&lang=js"
export * from "./game-redpipe.vue?vue&type=script&lang=js"
import style0 from "./game-redpipe.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-redpipe.vue
// module id = ho4n
// module chunks = 0